import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ResolveLibModule } from 'resolve-lib';
import { MenuOption, OptionGroup } from '../../models/menu-option';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { MenuInputComponent } from '../menu-input/menu-input.component';

@Component({
    selector: 'app-grouped-select-menu',
    templateUrl: './grouped-select-menu.component.html',
    styleUrls: ['./grouped-select-menu.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        DropdownComponent,
        MenuInputComponent,
        ResolveLibModule,
    ]
})
export class GroupedSelectMenuComponent {
  @ViewChild(DropdownComponent) dropdown!: DropdownComponent;
  @Input() optionGroup: OptionGroup[] = [];
  @Input() disabledGroup: OptionGroup[] = [];
  @Input() disabledLabel: string = 'Disabled Options';
  @Input() placeholder: string = 'Select an option';
  @Input() hasPlaceholderOption: boolean = true;
  @Input() selectedOption: MenuOption | null = null;
  @Input() fullWidth: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() label: string = 'Select Menu';

  @Output() changeEvent = new EventEmitter<MenuOption | null>();

  onSelectionChange(value: string) {
    if (!value) {
      this.changeEvent.emit(null);
      if (this.dropdown) {
        this.dropdown.onClickOutside(false);
      }
      return;
    }

    const found =
      this.optionGroup.at(0)?.options.find((o) => o.value === value) ?? null;
    this.changeEvent.emit(found ?? null);
    if (this.dropdown) {
      this.dropdown.onClickOutside(false);
    }
  }
}
